module.exports = __webpack_public_path__ + "img/chickenvesuvio.7693de2e.jpg";